import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const paymentsNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.INITIATE_PAYMENT_SUMMARY,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-summary',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-insufficient-funds',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.SUBMIT_PAYMENT,
    {
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-payment-processing',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-success',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-declined',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.PISP_REVIEW,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.PISP_DEPOSIT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.PROCESSING]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.PAY_NEW_INTL_BENEFICIARY,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-pay-beneficiary',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-no-source-currency-account',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.INTL_TRANSFER_PRECHECK,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-insufficient-funds',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.INIT_INTL_PAYMENT,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-payment-success',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-payment-processing',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'intl-payment-failed',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.CHECK_SMS_AUTH_STATUS_AND_REDIRECT,
    {
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-processing',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-success',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-declined',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_APPROVE,
    {
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-request-processing',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-request-success',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-request-failed',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_REJECT,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-request-failed',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PROFILE,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'notification-centre',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.PAYMENT_APPROVER_MAKE_PAYMENT,
    {
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-processing-initiator',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-success-initiator',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-failed-initiator',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_PROCESSING,
    {
      [ActionButtonOutcomesType.PROCESSING]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'payment-processing',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'request-sent-successfully',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'request-failed-to-send',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.CANCEL_SCHEDULED_PAYMENT,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.LANDING,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'home',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.LANDING,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'home',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
]);
